import { motion } from "framer-motion";
import { Scale } from "lucide-react";
import AlabamaMap from "@/components/AlabamaMap";
import LegislationTracker from "@/components/LegislationTracker";

const LegislationShowcase = () => {
  return (
    <section id="lobbying" className="relative bg-background border-t border-border">
      <div className="container mx-auto px-6 pt-20 md:pt-28">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-primary/30 bg-primary/5 text-primary">
              <Scale className="h-4 w-4" />
            </span>
            <span className="text-primary text-xs font-semibold tracking-[0.2em] uppercase">
              Practice 01 · Lobbying
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
            Every bill that <span className="text-gradient-primary">matters</span>, tracked live
          </h2>
          <p className="text-muted-foreground text-base md:text-lg leading-relaxed">
            We monitor Alabama legislation across all 67 counties, brief clients on what's moving, and engage legislators on the bills shaping their work. The dashboards below are the same tools our team uses every day.
          </p>
        </motion.div>
      </div>
      <AlabamaMap />
      <LegislationTracker />
    </section>
  );
};

export default LegislationShowcase;